import { RoundCloseButton } from 'components/common/buttons/RoundCloseButton';
import React from 'react'
import { Modal } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { Url } from '_constants';
import { PixelHelper } from '_utils/PixelHelper';

const CrowdFund: React.FunctionComponent<{onClose: ()=>void}> = ({onClose}) => {

  const navigate = useNavigate();

  const imageStyle: React.CSSProperties = {
    width: "9.375rem",
  }

  const onClick = () => {
    onClose();
    PixelHelper.trackGAEvent('click_modal_crowd_fund_learn_more');
    navigate(Url.CROWD_FUNDING);
  }

  return (
    <div className="p-4 pt-3 d-flex flex-column gap-3 justify-content-center align-items-center">

      <div className="align-self-end mb-1">
        <RoundCloseButton onClick={onClose} />
      </div>
      <div>
        <img style={imageStyle} src="/images/crowd-funding/logo-with-line-up.svg" alt='Predictagram' />
      </div>

      <div className="text-18 fw-bold">Be part of our mission!</div>
      <div className="text-14 opacity-80">We're looking into letting our valued users become owners. Please let us know if you'd be interested by clicking the button below.</div>
      <button className="btn bg-lavender text-white w-100 p-3 mt-3" onClick={onClick}>Learn More &amp; Reserve</button>
    </div>
  );
}

export const ModalCrowdFunding:React.FunctionComponent<{ show: boolean; handleClose: () => void }> = ({show, handleClose}) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false} >
      <Modal.Body>
        <CrowdFund onClose={handleClose}/>
      </Modal.Body>
    </Modal>

  )

}


